function PageFooter() {
  return (
    <footer>
      <div className="wrap clearfix">
        <p>Copyrights 2026 All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default PageFooter;
